import TableTemplate, {
  IAdditional,
  IAdditionalHeaderProps,
} from "../../TableTemplate/tableTemplate";
import { TableCell } from "@mui/material";
import { IUpairSahraOrderReport } from "../../../Interfaces/uPairInterfaces";
import { useState } from "react";
import Modal from "../../../Components/Modal/Modal";
import Button from "../../../Components/Button";
import { CommonTableUI } from "../../TableTemplate/common";
import { toast } from "react-toastify";
import { packetErrorHandler } from "../../../Utils/requestUtils";
import DeleteIcon from "@mui/icons-material/Delete";
import FullScreenLoading from "../../../Components/Loading/FullScreenLoading";
import {
  cancelNLegsSahraFillOrder,
  getNLegsOrderFillTable,
} from "../../../Requests/nLegsRequests";
import { INLegOrderFillSearchParams } from "../../../Interfaces/nLegsInterfaces";

const NLegOrderTableAdditionalHeader = ({}: IAdditionalHeaderProps) => {
  return (
    <>
      <TableCell></TableCell>
      <TableCell></TableCell>
    </>
  );
};

const NLegOrderTableAdditionalCol: React.FC<{
  row: IUpairSahraOrderReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const [isOrderFillTableOpen, setIsOrderFillTableOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const deleteRowsOpenOrderHandler = () => {
    setLoading(true);
    cancelNLegsSahraFillOrder({ sahraOrderId: row.id })
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onAction();
        }
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <>
      {loading ? <FullScreenLoading /> : <></>}
      <TableCell>
        {isOrderFillTableOpen ? (
          <Modal title="جزئیات"
            UI={
              <TableTemplate<INLegOrderFillSearchParams, any>
                refreshTableTime={5000}
                getDataTable={(_, offset, pageSize) =>
                  getNLegsOrderFillTable(
                    { sahraOrderId: row.id },
                    offset,
                    pageSize
                  )
                }
                TableUI={({ reports, onAction }) => (
                  <CommonTableUI reports={reports} onAction={onAction} />
                )}
              />
            }
            onClose={() => setIsOrderFillTableOpen(false)}
          />
        ) : null}
        <Button
          onClick={() => setIsOrderFillTableOpen(true)}
          text="جزییات"
          variant="contained"
          className="table-btn"
        />
      </TableCell>

      <TableCell>
        {row.isActive ? (
          <div
            onClick={deleteRowsOpenOrderHandler}
            className="hover:bg-red-100 transition-all rounded p-1"
          >
            <DeleteIcon
              fontSize="small"
              className="text-red-700 cursor-pointer"
            />
          </div>
        ) : (
          <></>
        )}
      </TableCell>
    </>
  );
};

export const NLegOrderSahraOrderTableAdditional: IAdditional<IUpairSahraOrderReport> =
  {
    getHeader: NLegOrderTableAdditionalHeader,
    getRow: NLegOrderTableAdditionalCol,
  };
